import team1 from "../../Assets/TalentOnDemand/team1.png";
import team10 from "../../Assets/TalentOnDemand/team10.png";
import team11 from "../../Assets/TalentOnDemand/team11.png";
import team12 from "../../Assets/TalentOnDemand/team12.png";
import team2 from "../../Assets/TalentOnDemand/team2.png";
import team3 from "../../Assets/TalentOnDemand/team3.png";
import team4 from "../../Assets/TalentOnDemand/team4.png";
import team5 from "../../Assets/TalentOnDemand/team5.png";
import team6 from "../../Assets/TalentOnDemand/team6.png";
import team7 from "../../Assets/TalentOnDemand/team7.png";
import team8 from "../../Assets/TalentOnDemand/team8.png";
import team9 from "../../Assets/TalentOnDemand/team9.png";

const TalentOnDemandMainTeam = () => {
    const cardData = [
        {
            title: "Talent Acquisition &<br/> Recruiting",
            body: "We’re experts at selecting the top talent.",
            imageTitle1: "Director",
            imageURL1: team1,
            imageTitle2: "Operations",
            imageURL2: team2,
        },
        {
            title: "Technical<br/> Recruiter",
            body: "Sources candidates for technical roles.",
            imageTitle1: "Director",
            imageURL1: team3,
            imageTitle2: "Operations",
            imageURL2: team4,
        },
        {
            title: "Diversity & Inclusion<br/> Specialist",
            body: "Ensures diversity; attracts & includes talent.",
            imageTitle1: "Manager",
            imageURL1: team5,
            imageTitle2: "Operations",
            imageURL2: team6,
        },
        {
            title: "Sourcing & Experience<br/> Specialist",
            body: "Advanced techniques to find candidates.",
            imageTitle1: "Director",
            imageURL1: team7,
            imageTitle2: "Operations",
            imageURL2: team8,
        },
        {
            title: "Research<br/> Analyst",
            body: "Optimizes hiring with data-driven insights.",
            imageTitle1: "Director",
            imageURL1: team9,
            imageTitle2: "Operations",
            imageURL2: team10,
        },
        {
            title: "Onboarding<br/> Specialist",
            body: "Manages onboarding for productivity.",
            imageTitle1: "Director",
            imageURL1: team11,
            imageTitle2: "Operations",
            imageURL2: team12,
        }
    ];

    return (
        <section className="w-full bg-black flex flex-col items-center justify-between gap-4 py-8 md:pt-20">
            <div className="px-4 lg:px-0 max-w-7xl w-full">
                <h2 className="text-2xl md:text-5xl xl:text-7xl text-white font-semibold text-center flex items-start justify-center">
                    Fractional Recruiting Team
                    <span className="text-xl md:text-3xl font-normal">&#8482;</span>
                </h2>
                <h4 className="text-center w-full mx-auto md:w-fit text-white md:text-2xl mt-4">
                    Available 24/7
                </h4>
                <div className="mt-8">
                    <div className="grid-cols-1 sm:grid sm:grid-cols-2 lg:grid-cols-2 gap-6 hidden">
                        {
                            cardData.map((card, index) => (
                                <div key={index} className="bg-white justify-between p-6 md:p-10 rounded-2xl flex flex-col lg:flex-row gap-4 h-full">
                                    <div className="flex flex-col gap-3">
                                        <h3
                                            className="text-xl md:text-2xl font-bold text-black"
                                            dangerouslySetInnerHTML={{ __html: String(card.title) }}
                                        />
                                        <p className="text-sm md:text-md mt-2">{card.body}</p>
                                    </div>
                                    <div className="grid grid-cols-2 items-center justify-between gap-y-1">
                                        <img src={card.imageURL1} alt={card.imageTitle1} className="w-16 h-16 rounded-full mx-auto" />
                                        <img src={card.imageURL2} alt={card.imageTitle2} className="w-16 h-16 rounded-full mx-auto" />
                                        <span className="text-sm mx-auto">{card.imageTitle1}</span>
                                        <span className="text-sm mx-auto">{card.imageTitle2}</span>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <div className="flex sm:hidden overflow-x-auto gap-4 snap-x snap-mandatory scroll-smooth px-1">
                        {
                            cardData.map((card, index) => (
                                <div key={index} className="min-w-[90%] lg:max-w-none max-w-[200px] snap-center bg-white p-6 rounded-2xl flex-shrink-0 flex flex-col gap-4">
                                    <div className="flex flex-col gap-3">
                                        <h3
                                            className="text-xl font-bold text-black"
                                            dangerouslySetInnerHTML={{ __html: String(card.title) }}
                                        />
                                        <p className="text-sm mt-2">{card.body}</p>
                                    </div>
                                    <div className="grid grid-cols-2 items-center justify-between gap-y-1">
                                        <img src={card.imageURL1} alt={card.imageTitle1} className="lg:w-16 lg:h-16 w-24 h-24 rounded-full mx-auto" />
                                        <img src={card.imageURL2} alt={card.imageTitle2} className="lg:w-16 lg:h-16 w-24 h-24 rounded-full mx-auto" />
                                        <span className="text-sm mx-auto">{card.imageTitle1}</span>
                                        <span className="text-sm mx-auto">{card.imageTitle2}</span>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TalentOnDemandMainTeam;
